import Children from '../../../layouts/Children';

const routes = [
  {
    path: 'appcontent',
    component: Children,

    children: [
      {
        path: '',
        name: 'appcontent',
        component: () =>
          import('@/modules/app_content/pages/AppContentPage.vue')
      },
      {
        path: 'html',
        component: Children,
        children: [
          {
            path: 'create',
            name: 'html.create',
            component: () =>
              import(
                '@/modules/app_content/pages/html/AppContentCreatePage.vue'
              )
          },
          {
            path: ':id/edit',
            name: 'html.edit',
            component: () =>
              import('@/modules/app_content/pages/html/AppContentEditPage.vue'),
            props: route => ({
              id: Number(route.params.id)
            })
          }
        ]
      },
      {
        path: 'iframe',
        component: Children,
        children: [
          {
            path: 'create',
            name: 'iframe.create',
            component: () =>
              import(
                '@/modules/app_content/pages/iframe/AppContentCreatePage.vue'
              )
          },
          {
            path: ':id/edit',
            name: 'iframe.edit',
            component: () =>
              import(
                '@/modules/app_content/pages/iframe/AppContentEditPage.vue'
              ),
            props: route => ({
              id: Number(route.params.id)
            })
          }
        ]
      },
      {
        path: 'link',
        component: Children,
        children: [
          {
            path: 'create',
            name: 'link.create',
            component: () =>
              import(
                '@/modules/app_content/pages/link/AppContentCreatePage.vue'
              )
          },
          {
            path: ':id/edit',
            name: 'link.edit',
            component: () =>
              import('@/modules/app_content/pages/link/AppContentEditPage.vue'),
            props: route => ({
              id: Number(route.params.id)
            })
          }
        ]
      }
    ]
  }
];

export default routes;
